import { IconButton, InputAdornment } from '@mui/material';
import PasswordEyeIcon from 'components/Icons/PasswordEyeIcon';
import PasswordEyeOffIcon from 'components/Icons/PasswordEyeOffIcon';
import { forwardRef, useState } from 'react';

import type { ICustomTextFieldProps } from './index';
import LabelledTextField from './index';

const PasswordField = forwardRef(
  ({ type = 'text', ...props }: ICustomTextFieldProps, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleToggleShowPassword = () => {
      setShowPassword(!showPassword);
    };

    return (
      <LabelledTextField
        type={showPassword ? type : 'password'}
        {...props}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleToggleShowPassword}
                className="bg-transparent"
              >
                {showPassword ? <PasswordEyeIcon /> : <PasswordEyeOffIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...{ ref }}
      />
    );
  }
);

PasswordField.displayName = 'PasswordField';
PasswordField.defaultProps = {
  label: '',
  variant: 'standard',
  ref: null,
  type: 'text',
  error: false,
  helperText: '',
  className: '',
  inputRef: null,
  required: false,
};

export default PasswordField;
